import request from "@/utils/request";
import qs from "qs";
import { VXETable } from "vxe-table";

export function userId2EmpName() {
  return request({
    url: "/user/userId2EmpName",
    method: "post"
  });
}

export function coachSportId(data) {
  return request({
    url: "/group/select_coach_by_sportId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function centerUserSelect(data) {
  return request({
    url: "/center/centerUserSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

//查看笔记
export function teach_context(data) {
  return request({
    url: "/data/teach_context/select",
    method: "get",
    params: data
  });
}

//添加笔记
export function teach_context_add(data) {
  return request({
    url: "/data/teach_context/add",
    method: "get",
    params: data
  });
}

//修改笔记
export function teach_context_update(data) {
  return request({
    url: "/data/teach_context/update",
    method: "get",
    params: data
  });
}



export function getPersonByOrgEmp(data) {
  return request({
    url: "/person/getPersonByOrgEmp",
    method: "post"
  });
}

export function empInit(data) {
  return request({
    url: "/meta/employee/empInit",
    method: "post"
  });
}

export function sport_item_by_sportId(data) {
  return request({
    url: "/meta/sport_item/by_sportId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getAllEmp(data) {
  return request({
    url: "/meta/employee/getAllEmp",
    method: "post",
    data: qs.stringify(data)
  });
}

export function currentRoleEmployee(data) {
  return request({
    url: "/meta/employee/json/currentRoleEmployee",
    method: "post",
    data: qs.stringify(data)
  });
}

export function personDetail(data) {
  return request({
    url: "/person/personDetail",
    method: "post",
    data: qs.stringify(data)
  });
}

export function personByIdNo(data) {
  return request({
    url: "/person/personByIdNo",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getEmpRoughly(data) {
  return request({
    url: "/meta/employee/getEmpRoughly/" + data,
    method: "post"
  });
}

export function emp_by_pid_insert(data) {
  return request({
    url: "/meta/employee/emp_by_pid_insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function player_coach_map(data) {
  return request({
    url: "/meta/player_coach_map/selectByPerson/" + data.pId,
    method: "post",
    data: qs.stringify({
      isPlayer: data.isPlayer
    })
  });
}

export function player_coach_map_insert(data) {
  return request({
    url: "/meta/player_coach_map/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function player_coach_map_update(data) {
  return request({
    url: "/meta/player_coach_map/update/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function player_coach_map_delete(data) {
  return request({
    url: "/meta/player_coach_map/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_profile(data) {
  return request({
    url: "/person/profile/byPid/" + data,
    method: "post"
  });
}

export function changeDivisionCY(data) {
  return request({
    url: "/person/division/changeDivisionCY",
    method: "post",
    data: qs.stringify(data)
  });
}

export function changeDivision(data) {
  return request({
    url: "/person/division/changeDivision",
    method: "post",
    data: qs.stringify(data)
  });
}

export function profile_insert(data) {
  return request({
    url: "/person/profile/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function profile_update(data) {
  return request({
    url: "/person/profile/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function profile_delete(data) {
  return request({
    url: "/person/profile/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function coach_sport_map(data) {
  return request({
    url: "/coach_sport_map/json/all/" + data,
    method: "post"
  });
}

export function coach_byPId(data) {
  return request({
    url: "/meta/coach/byPId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function coach_sport_map_insert(data) {
  return request({
    url: "/coach_sport_map/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function coach_sport_map_update(data) {
  return request({
    url: "/coach_sport_map/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function coach_sport_map_delete(data) {
  return request({
    url: "/coach_sport_map/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire(data) {
  return request({
    url: "/employee_hire/json/all/" + data,
    method: "post"
  });
}

export function employee_hire_insert(data) {
  return request({
    url: "/employee_hire/json/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function employee_hire_update(data) {
  return request({
    url: "/employee_hire/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire_delete(data) {
  return request({
    url: "/employee_hire/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_family(data) {
  return request({
    url: "/person/family/select/" + data,
    method: "post"
  });
}

export function person_family_insert(data) {
  return request({
    url: "/person/family/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_family_update(data) {
  return request({
    url: "/person/family/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_family_delete(data) {
  return request({
    url: "/person/family/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_language(data) {
  return request({
    url: "/person/language/select/" + data,
    method: "post"
  });
}

export function person_language_insert(data) {
  return request({
    url: "/person/language/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_language_update(data) {
  return request({
    url: "/person/language/json/update/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_language_delete(data) {
  return request({
    url: "/person/language/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}
export function person_officeholdHistory(data) {
  return request({
    url: "/person/officeholdHistory/select/" + data,
    method: "post"
  });
}

export function person_officeholdHistory_insert(data) {
  return request({
    url: "/person/officeholdHistory/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_officeholdHistory_update(data) {
  return request({
    url: "/person/officeholdHistory/update/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_officeholdHistory_delete(data) {
  return request({
    url: "/person/officeholdHistory/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_personEducation(data) {
  return request({
    url: "/person/personEducation/select/" + data,
    method: "post"
  });
}

export function person_personEducation_insert(data) {
  return request({
    url: "/person/personEducation/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_update(data) {
  return request({
    url: "/person/personEducation/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_delete(data) {
  return request({
    url: "/person/personEducation/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_paper(data) {
  return request({
    url: "/person/paper/select/" + data,
    method: "post"
  });
}

export function person_paper_insert(data) {
  return request({
    url: "/person/paper/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_paper_update(data) {
  return request({
    url: "/person/paper/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_paper_delete(data) {
  return request({
    url: "/person/paper/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_professionLevel(data) {
  return request({
    url: "/person/professionLevel/select/" + data,
    method: "post"
  });
}

export function person_professionLevel_insert(data) {
  return request({
    url: "/person/professionLevel/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_professionLevel_update(data) {
  return request({
    url: "/person/professionLevel/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_professionLevel_delete(data) {
  return request({
    url: "/person/professionLevel/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_referee(data) {
  return request({
    url: "/person/referee/select/" + data,
    method: "post"
  });
}

export function person_referee_insert(data) {
  return request({
    url: "/person/referee/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_referee_update(data) {
  return request({
    url: "/person/referee/update/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_referee_delete(data) {
  return request({
    url: "/person/referee/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_rewardPunishment(data) {
  return request({
    url: "/person/rewardPunishment/select/" + data,
    method: "post"
  });
}

export function person_rewardPunishment_insert(data) {
  return request({
    url: "/person/rewardPunishment/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_rewardPunishment_update(data) {
  return request({
    url: "/person/rewardPunishment/update/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_rewardPunishment_delete(data) {
  return request({
    url: "/person/rewardPunishment/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function qualification(data) {
  return request({
    url: "/qualification/json/select/" + data,
    method: "post"
  });
}

export function qualification_insert(data) {
  return request({
    url: "/qualification/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function qualification_update(data) {
  return request({
    url: "/qualification/json/update/",
    method: "post",
    data: qs.stringify(data)
  });
}

export function qualification_delete(data) {
  return request({
    url: "/qualification/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_furtherEducation(data) {
  return request({
    url: "/person/furtherEducation/select/" + data,
    method: "post"
  });
}

export function person_furtherEducation_insert(data) {
  return request({
    url: "/person/furtherEducation/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_furtherEducation_update(data) {
  return request({
    url: "/person/furtherEducation/update/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_furtherEducation_delete(data) {
  return request({
    url: "/person/furtherEducation/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function player_important_map(data) {
  return request({
    url: "/player_important_map/json/all/" + data,
    method: "post"
  });
}

export function player_important_map_insert(data) {
  return request({
    url: "/player_important_map/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_important_map_update(data) {
  return request({
    url: "/player_important_map/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_important_map_delete(data) {
  return request({
    url: "/player_important_map/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empByOrg(data) {
  return request({
    url: "/idCard/json/empByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empByOrg_update(data) {
  return request({
    url: "/idCard/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empByOrg_check(data) {
  return request({
    url: "/idCard/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empByOrg_select(data) {
  return request({
    url: "/idCard/json/empSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empBasicInfo_empByOrg(data) {
  return request({
    url: "/person/profile/json/empByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empBasicInfo_insert(data) {
  return request({
    url: "/person/profile/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empBasicInfo_empByOrg_update(data) {
  return request({
    url: "/person/profile/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empBasicInfo_empByOrg_check(data) {
  return request({
    url: "/person/profile/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function empBasicInfo_empByOrg_select(data) {
  return request({
    url: "/person/profile/json/empSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_language_select(data) {
  return request({
    url: "/person/language/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_language_insertByEmpId(data) {
  return request({
    url: "/person/language/insertByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_language_updateByEmpId(data) {
  return request({
    url: "/person/language/updateByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_language_deleteByEmpId(data) {
  return request({
    url: "/person/language/deleteByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_language_check(data) {
  return request({
    url: "/person/language/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_officeholdHistory_all(data) {
  return request({
    url: "/person/officeholdHistory/statistics/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function allPersonFromEmployee(data) {
  return request({
    url: "/person/allPersonFromEmployee",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_officeholdHistory_insert2(data) {
  return request({
    url: "/person/officeholdHistory/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_officeholdHistory_select(data) {
  return request({
    url: "/person/officeholdHistory/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_officeholdHistory_update2(data) {
  return request({
    url: "/person/officeholdHistory/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_officeholdHistory_delete2(data) {
  return request({
    url: "/person/officeholdHistory/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_officeholdHistory_check(data) {
  return request({
    url: "/person/officeholdHistory/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_select(data) {
  return request({
    url: "/person/personEducation/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_insertByEmpId(data) {
  return request({
    url: "/person/personEducation/insertByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_updateByEmpId(data) {
  return request({
    url: "/person/personEducation/updateByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_deleteByEmpId(data) {
  return request({
    url: "/person/personEducation/deleteByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_personEducation_check(data) {
  return request({
    url: "/person/personEducation/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function pcm4emp(data) {
  return request({
    url: "/meta/player_coach_map/pcm4emp",
    method: "post",
    data: qs.stringify(data)
  });
}

export function pcm4coach(data) {
  return request({
    url: "/meta/player_coach_map/pcm4coach",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire_all(data) {
  return request({
    url: "/employee_hire/statistics/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire_insert2(data) {
  return request({
    url: "/employee_hire/statistics/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire_update2(data) {
  return request({
    url: "/employee_hire/statistics/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire_check(data) {
  return request({
    url: "/employee_hire/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function employee_hire_select(data) {
  return request({
    url: "/employee_hire/statistics/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_coach_map_selectDefault(data) {
  return request({
    url: "/meta/player_coach_map/selectDefault",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_coach_map_statistics_insert(data) {
  return request({
    url: "/meta/player_coach_map/statistics/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_coach_map_statistics_update(data) {
  return request({
    url: "/meta/player_coach_map/statistics/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_coach_map_statistics_delete(data) {
  return request({
    url: "/meta/player_coach_map/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_coach_map_statistics_select(data) {
  return request({
    url: "/meta/player_coach_map/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function professionLevel_select(data) {
  return request({
    url: "/person/professionLevel/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function professionLevel_insertByCoachId(data) {
  return request({
    url: "/person/professionLevel/insertByCoachId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function professionLevel_updateByCoachId(data) {
  return request({
    url: "/person/professionLevel/updateByCoachId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function professionLevel_deleteByCoachId(data) {
  return request({
    url: "/person/professionLevel/deleteByCoachId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function professionLevel_check(data) {
  return request({
    url: "/person/professionLevel/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function coach_by_sport(data) {
  return request({
    url: "/meta/coach/coach_by_sport",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_referee_all(data) {
  return request({
    url: "/person/referee/statistics/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function referee_insert(data) {
  return request({
    url: "/person/referee/statistics/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function referee_update(data) {
  return request({
    url: "/person/referee/statistics/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function referee_delete(data) {
  return request({
    url: "/person/referee/statistics/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function referee_check(data) {
  return request({
    url: "/person/referee/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function referee_select(data) {
  return request({
    url: "/person/referee/statistics/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_getEmpRP(data) {
  return request({
    url: "/person/rewardPunishment/getEmpRP",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_insertRPEmp(data) {
  return request({
    url: "/person/rewardPunishment/insertRPEmp",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_updateRPEmp(data) {
  return request({
    url: "/person/rewardPunishment/updateRPEmp",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_deleteRPEmp(data) {
  return request({
    url: "/person/rewardPunishment/deleteRPEmp",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_checkRPEmp(data) {
  return request({
    url: "/person/rewardPunishment/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_selectRPEmp(data) {
  return request({
    url: "/person/rewardPunishment/selectRPEmp",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getBasicInfoByPid(data) {
  return request({
    url: "/person/getBasicInfoByPid",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_qualification_all(data) {
  return request({
    url: "/qualification/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_qualification_insert(data) {
  return request({
    url: "/qualification/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_qualification_update(data) {
  return request({
    url: "/qualification/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_qualification_check(data) {
  return request({
    url: "/qualification/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_qualification_select(data) {
  return request({
    url: "/qualification/json/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function furtherEducation_selectByOrg(data) {
  return request({
    url: "/person/furtherEducation/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function furtherEducation_insert(data) {
  return request({
    url: "/person/furtherEducation/insertByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function furtherEducation_update(data) {
  return request({
    url: "/person/furtherEducation/updateByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function furtherEducation_delete(data) {
  return request({
    url: "/person/furtherEducation/deleteByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function furtherEducation_check(data) {
  return request({
    url: "/person/furtherEducation/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function furtherEducation_select(data) {
  return request({
    url: "/person/furtherEducation/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function paper_select(data) {
  return request({
    url: "/person/paper/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function paper_insertByEmpId(data) {
  return request({
    url: "/person/paper/insertByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function paper_updateByEmpId(data) {
  return request({
    url: "/person/paper/updateByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function paper_deleteByEmpId(data) {
  return request({
    url: "/person/paper/deleteByEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function paper_check(data) {
  return request({
    url: "/person/paper/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function personEducation_selectTopEduByOrg(data) {
  return request({
    url: "/person/personEducation/selectTopEduByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function personEducation_checkTopEduByOrg(data) {
  return request({
    url: "/person/personEducation/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_select(data) {
  return request({
    url: "/meta/player/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getPid(data) {
  return request({
    url: "/meta/player/getPid",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_selectBySearch(data) {
  return request({
    url: "/meta/player/selectBySearch",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getPlayerRoughly(data) {
  return request({
    url: "/meta/player/json/getPlayerRoughly/" + data,
    method: "post"
  });
}

export function player_info_insert(data) {
  return request({
    url: "/meta/player/json/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function playerSelect(data) {
  return request({
    url: "/meta/player/playerSelect/" + data,
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerMessageUpdate(data) {
  return request({
    url: "/meta/player/playerMessageUpdate/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function schoolRoll_select(data) {
  return request({
    url: "/person/schoolRoll/json/select/" + data,
    method: "post"
  });
}

export function schoolRoll_insert(data) {
  return request({
    url: "/person/schoolRoll/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function schoolRoll_update(data) {
  return request({
    url: "/person/schoolRoll/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function schoolRoll_delete(data) {
  return request({
    url: "/person/schoolRoll/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function transport_select(data) {
  return request({
    url: "/person/transport/select/" + data,
    method: "post"
  });
}

export function transport_insert(data) {
  return request({
    url: "/person/transport/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function transport_update(data) {
  return request({
    url: "/person/transport/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function transport_delete(data) {
  return request({
    url: "/person/transport/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_training(data) {
  return request({
    url: "/person/training/select/" + data,
    method: "post"
  });
}

export function person_training_insert(data) {
  return request({
    url: "/person/training/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_training_update(data) {
  return request({
    url: "/person/training/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_training_delete(data) {
  return request({
    url: "/person/training/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function all_org_insert(data) {
  return request({
    url: "/all_org/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_sportResume(data) {
  return request({
    url: "/person/sportResume/select/" + data,
    method: "post"
  });
}

export function person_sportResume_insert(data) {
  return request({
    url: "/person/sportResume/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_sportResume_update(data) {
  return request({
    url: "/person/sportResume/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_sportResume_delete(data) {
  return request({
    url: "/person/sportResume/delete/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_match(data) {
  return request({
    url: "/match/json/all/" + data,
    method: "post"
  });
}

export function person_match_insert(data) {
  return request({
    url: "/match/json/insert/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function person_match_update(data) {
  return request({
    url: "/match/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_match_delete(data) {
  return request({
    url: "/match/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function match_event_item_by_matchEventId(data) {
  return request({
    url: "/match/match_event_item/json/all/" + data,
    method: "post"
  });
}

export function match_event_item_insert(data) {
  return request({
    url: "/match/match_event_item/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function match_group_type_insert(data) {
  return request({
    url: "/match/match_group_type/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function delegation_insert(data) {
  return request({
    url: "/match/delegation/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function match_address_insert(data) {
  return request({
    url: "/match/match_address/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_update(data) {
  return request({
    url: "/meta/player/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerByOrg(data) {
  return request({
    url: "/idCard/json/playerByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

//查询运动员录入记录
export function playerLogInfo(data) {
  return request({
    url: "/person/profile/json/playerLogInfo",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getPersonByOrgPlayer(data) {
  return request({
    url: "/person/getPersonByOrgPlayer",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerByOrg_update(data) {
  return request({
    url: "/idCard/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerByOrg_check(data) {
  return request({
    url: "/idCard/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerByOrg_select(data) {
  return request({
    url: "/idCard/json/playerSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_profile_playerByOrg(data) {
  return request({
    url: "/person/profile/json/playerByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_profile_insert(data) {
  return request({
    url: "/person/profile/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_profile_update(data) {
  return request({
    url: "/person/profile/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_profile_check(data) {
  return request({
    url: "/person/profile/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_profile_playerSelect(data) {
  return request({
    url: "/person/profile/json/playerSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerOfThisSportAndCoach(data) {
  return request({
    url: "/meta/player/playerOfThisSportAndCoach",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_joinTeam_select(data) {
  return request({
    url: "/meta/player/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_joinTeam_update(data) {
  return request({
    url: "/meta/player/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_joinTeam_playerSelect(data) {
  return request({
    url: "/meta/player/playerSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_family(data) {
  return request({
    url: "/person/family/playerSelect",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_family_insert(data) {
  return request({
    url: "/person/family/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_family_update(data) {
  return request({
    url: "/person/family/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_family_check(data) {
  return request({
    url: "/person/family/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_family_delete(data) {
  return request({
    url: "/person/family/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function pcm4player(data) {
  return request({
    url: "/meta/player_coach_map/pcm4player",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_education(data) {
  return request({
    url: "/person/personEducation/selectPlayer",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_education_insert(data) {
  return request({
    url: "/person/personEducation/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_education_update(data) {
  return request({
    url: "/person/personEducation/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_education_delete(data) {
  return request({
    url: "/person/personEducation/deleteByPid",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_education_check(data) {
  return request({
    url: "/person/personEducation/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_schoolRoll(data) {
  return request({
    url: "/person/schoolRoll/allSchoolRoll",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_schoolRoll_insert(data) {
  return request({
    url: "/person/schoolRoll/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_schoolRoll_update(data) {
  return request({
    url: "/person/schoolRoll/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_schoolRoll_check(data) {
  return request({
    url: "/person/schoolRoll/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_schoolRoll_delete(data) {
  return request({
    url: "/person/schoolRoll/deleteByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_rewardPunishment(data) {
  return request({
    url: "/person/rewardPunishment/selectRPPlayer",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_rewardPunishment_insert(data) {
  return request({
    url: "/person/rewardPunishment/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_rewardPunishment_update(data) {
  return request({
    url: "/person/rewardPunishment/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_rewardPunishment_delete(data) {
  return request({
    url: "/person/rewardPunishment/deleteBypId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_rewardPunishment_check(data) {
  return request({
    url: "/person/rewardPunishment/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_important_map_all4org(data) {
  return request({
    url: "/player_important_map/json/all4org",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_important_map_select(data) {
  return request({
    url: "/player_important_map/json/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_professionLevel(data) {
  return request({
    url: "/person/professionLevel/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_professionLevel_insert(data) {
  return request({
    url: "/person/professionLevel/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_professionLevel_update(data) {
  return request({
    url: "/person/professionLevel/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_professionLevel_delete(data) {
  return request({
    url: "/person/professionLevel/deleteByPid",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_professionLevel_check(data) {
  return request({
    url: "/person/professionLevel/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_sportResume(data) {
  return request({
    url: "/person/sportResume/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_sportResume_insert(data) {
  return request({
    url: "/person/sportResume/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_sportResume_update(data) {
  return request({
    url: "/person/sportResume/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_sportResume_delete(data) {
  return request({
    url: "/person/sportResume/deleteByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_sportResume_check(data) {
  return request({
    url: "/person/sportResume/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_training(data) {
  return request({
    url: "/person/training/selectByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_training_insert(data) {
  return request({
    url: "/person/training/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_training_update(data) {
  return request({
    url: "/person/training/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_training_check(data) {
  return request({
    url: "/person/training/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_training_delete(data) {
  return request({
    url: "/person/training/deleteByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm2player(data) {
  return request({
    url: "/dorm2player/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm2player_insert(data) {
  return request({
    url: "/dorm2player/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm2player_update(data) {
  return request({
    url: "/dorm2player/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm2player_delete(data) {
  return request({
    url: "/dorm2player/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm2player_select(data) {
  return request({
    url: "/dorm2player/json/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm_all(data) {
  return request({
    url: "/dorm/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm_insert(data) {
  return request({
    url: "/dorm/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm_update(data) {
  return request({
    url: "/dorm/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm_delete(data) {
  return request({
    url: "/dorm/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function dorm_select(data) {
  return request({
    url: "/dorm/json/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_match(data) {
  return request({
    url: "/match/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}
//比赛成绩简录-表格所有数据
export function match_data_synthesize(data) {
  return request({
    url: "/data/match_data_synthesize/select",
    method: "get",
    params: data
  });
}

//比赛成绩简录-修改
export function match_data_synthesize_update(data) {
  return request({
    url: '/data/match_data_synthesize/update',
    method: 'get',
    params: data
  })

}

export function player_match_insert(data) {
  return request({
    url: "/match/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}
//比赛成绩简录-新增比赛成绩
export function match_data_synthesize_add(data) {
  return request({
    url: "/data/match_data_synthesize/add",
    method: "get",
    params: data
  });
}

export function player_match_update(data) {
  return request({
    url: "/match/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_match_check(data) {
  return request({
    url: "/match/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_match_delete(data) {
  return request({
    url: "/match/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}
//比赛成绩简录-删除
export function match_data_synthesize_delete(data) {

  return request({
    url: "/data/match_data_synthesize/delete",
    method: "get",
    params: data
  });
}


export function player_match_select(data) {
  return request({
    url: "/match/json/select",
    method: "post",
    data: qs.stringify(data)
  });
}

export function match_fileUpload(data) {
  return request({
    url: "/match/fileUpload",
    method: "post",
    data: data
  });
}

export function match_filePath4pdf(data) {
  return request({
    url: "/match/filePath4pdf",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_transport(data) {
  return request({
    url: "/person/transport/transportByOrg",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_transport_insert(data) {
  return request({
    url: "/person/transport/insertByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_transport_update(data) {
  return request({
    url: "/person/transport/updateByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_transport_check(data) {
  return request({
    url: "/person/transport/json/check",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_transport_delete(data) {
  return request({
    url: "/person/transport/deleteByPlayerId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function transport_fileUpload(data) {
  return request({
    url: "/person/transport/fileUpload",
    method: "post",
    data: data
  });
}

export function transport_filePath4pdf(data) {
  return request({
    url: "/person/transport/filePath4pdf",
    method: "post",
    data: qs.stringify(data)
  });
}

export function injury_record(data) {
  return request({
    url: "/medical/injury_record/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function injury_record_dict(data) {
  return request({
    url: "/medical/injury_record/dict",
    method: "post",
    data: qs.stringify(data)
  });
}

export function injury_record_search(data) {
  return request({
    url: "/medical/injury_record/json/search",
    method: "post",
    data: qs.stringify(data)
  });
}

export function currentTerm(data) {
  return request({
    url: "/edu/currentTerm",
    method: "post",
    data: qs.stringify(data)
  });
}

export async function get_player(data) {
  let res = await request({
    url: "/meta/player_coach_map/get_player",
    method: "post",
    data: qs.stringify(data)
  });

  return res;
}

export async function orgSubject(data) {
  let res = await request({
    url: "/edu/orgSubject",
    method: "post",
    data: qs.stringify(data)
  });
  let dict_subject = {};
  res.data.forEach(item => {
    dict_subject[item.subjectId] = item.name;
  });

  VXETable.renderer.add("dict_subjectIds", {
    renderDefault(h, renderOpts, params) {
      let { row, column } = params;

      let subjectNameArr = [];
      row[column.property]
        .split(",")
        .map(item => subjectNameArr.push(dict_subject[item]));
      return [subjectNameArr.join()];
    }
  });

  return res;
}

//查看文化成绩
export function result4coach(data) {
  return request({
    url: "/edu/result4coach",
    method: "post",
    data: qs.stringify(data)
  });
}

//删除文化成绩
export function result4coach_delete(data) {
  return request({
    url: "/edu/result4coach_delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function edu_examination_results(data) {
  return request({
    url: "/edu/edu_examination_results/batch_input",
    method: "post",
    headers: {
      "Content-Type": "application/json; charset=UTF-8"
    },
    data
  });
}

export function player_attendance_all(data) {
  return request({
    url: "/player_attendance/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_attendance_update(data) {
  return request({
    url: "/player_attendance/json/update",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_attendance_delete(data) {
  return request({
    url: "/player_attendance/json/delete",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_attendance_all_update(data) {
  return request({
    url: "/player_attendance/json/update_player_attendance",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_attendance_all_insert(data) {
  return request({
    url: "/player_attendance/json/insert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function month_player_attendance_all(data) {
  return request({
    url: "/player_attendance/json/player_attendance_all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerApplyDefault(data) {
  return request({
    url: "/process/playerApplyDefault",
    method: "post",
    data: qs.stringify(data)
  });
}

export function player_status(data) {
  return request({
    url: "/meta/player/status",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerApplyInsert(data) {
  return request({
    url: "/process/playerApplyInsert",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerApplyUpdate(data) {
  return request({
    url: "/process/playerApplyUpdate",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerApplyDetail(data) {
  return request({
    url: "/process/playerApplyDetail",
    method: "post",
    data: qs.stringify(data)
  });
}

export function process_playerInfo(data) {
  return request({
    url: "/process/playerInfo",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerAcceptDefault(data) {
  return request({
    url: "/process/playerAcceptDefault",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerAcceptUpdate(data) {
  return request({
    url: "/process/playerAcceptUpdate",
    method: "post",
    data: qs.stringify(data)
  });
}

export function passwordChange(data) {
  return request({
    url: "/passwordChange",
    method: "post",
    data: qs.stringify(data)
  });
}

export function person_attr(data) {
  return request({
    url: "person/attr",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getDetail(data) {
  return request({
    url: "/person/getDetail/" + data.pId,
    method: "post",
    data: qs.stringify(data.data)
  });
}

export function edu_subject(data) {
  return request({
    url: "/edu/edu_subject/json/all",
    method: "post",
    data: qs.stringify(data)
  });
}

export function bySchoolTerm(data) {
  return request({
    url: "/person/schoolTerm/bySchoolTerm",
    method: "post",
    data: qs.stringify(data)
  });
}

export function byCoachPid(data) {
  return request({
    url: "/meta/player/json/byCoachPid",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getRole4currentUser(data) {
  return request({
    url: "/role_user/getRole4currentUser",
    method: "post",
    data: qs.stringify(data)
  });
}

export function changeRole(data) {
  return request({
    url: "/role_user/changeRole",
    method: "post",
    data: qs.stringify(data)
  });
}

export async function currentRolePlayer(data) {
  let res = await request({
    url: "/meta/player/json/currentRolePlayer",
    method: "post",
    data: qs.stringify(data)
  });
  let dict_player = {};
  res.data.forEach(item => {
    dict_player[item.playerId] = item.name;
  });
  VXETable.renderer.add("dict_playerIds", {
    renderDefault(h, renderOpts, params) {
      let { row, column } = params;

      let playerNameArr = [];
      row[column.property]
        .split(",")
        .map(item => playerNameArr.push(dict_player[item]));
      return [playerNameArr.join()];
    }
  });
  return res;
}

export function player_coach_map_byEmpId(data) {
  return request({
    url: "/meta/player_coach_map/byEmpId",
    method: "post",
    data: qs.stringify(data)
  });
}

export function update_player_pending(data) {
  return request({
    url: "/player_attendance/json/update_player_pending",
    method: "post",
    data: qs.stringify(data)
  });
}

export function defaultCultureResultReport4coach(data) {
  return request({
    url: "/edu/defaultCultureResultReport4coach",
    method: "post",
    data: qs.stringify(data)
  });
}

export function playerApplyDelete(data) {
  return request({
    url: "/process/playerApplyDelete",
    method: "post",
    data: qs.stringify(data)
  });
}
//系统试卷
export function examination_sys(data) {
  return request({
    url: "/data/psychology_exam_question/all_exam",
    method: "get",
    params: qs.stringify(data)
  });
}


//获取当前时间的上一次考勤记录
export function player_up_attendance_all(data) {
  return request({
    url: "/player_attendance/json/up",
    method: "get",
    params: data
  });
}

export function examination_mine(data) {
  return request({
    url: "/data/psychology_exam_question/select_exam_org",
    method: "get",
    params: qs.stringify(data)
  });
}

export function addToMine(data) {
  return request({
    url: "/data/psychology_exam_question/add_exam_org",
    method: "get",
    params: data
  });
}

export function examination_delete(data) {
  return request({
    url: "/data/psychology_exam_question/delete_exam_org",
    method: "get",
    params: data
  });
}
//查看教练员名下试卷
export function paper_submit_preview(data) {
  return request({
    url: "/data/psychology_exam_question/select_player_exam",
    method: "get",
    params: data
  });
}
//查看试卷
export function examination_all(data) {
  return request({
    url: "/data/psychology_exam_question/exam_info_by_examOrgDataId",
    method: "get",
    params: data
  });
}

//查看填写的试卷
export function select_player_exam_info(data) {
  return request({
    url: "/data/psychology_exam_question/select_player_exam_info",
    method: "get",
    params: data
  });
}


export function examination_data_preview(data) {
  return request({
    url: "/examination/examination_data/once/" + data,
    method: "post"
  });
}

export function examination_evaluation(data) {
  return request({
    url: "/examination/evaluation",
    method: "post",
    data: qs.stringify(data)
  });
}

export function examination_all4player(data) {
  return request({
    url: "/examination/json/all4player",
    method: "post",
    data: qs.stringify(data)
  });
}

//交卷
export function examination_insert(data) {
  return request({
    url: "/data/psychology_exam_question/player_add_exam",
    method: "post",
    headers: {
      "Content-Type": "application/json; charset=UTF-8"
    },
    data: data
  });
}

export function upload_culture_result_from_excel(data) {
  return request({
    url: "/maintain/upload_culture_result_from_excel",
    method: "post",
    data: data
  });
}
export function upload_meta_from_excel(data) {
  return request({
    url: "/maintain/upload_meta_from_excel",
    method: "post",
    data: data
  });
}

export function gen_meta_data_niaochanggui_from_excel(data) {
  return request({
    url: "/maintain/gen_meta_data_niaochanggui_from_excel",
    method: "post",
    data: data
  });
}

export function upload_meta_data_from_excel(data) {
  return request({
    url: "/maintain/upload_meta_data_from_excel",
    method: "post",
    data: data
  });
}

export function upload_person_and_idcard_from_excel(data) {
  return request({
    url: "/maintain/upload_person_and_idcard_from_excel",
    method: "post",
    data: data
  });
}

export function upload_player_from_excel(data) {
  return request({
    url: "/maintain/upload_player_from_excel",
    method: "post",
    data: data
  });
}

export function upload_employee_from_excel(data) {
  return request({
    url: "/maintain/upload_employee_from_excel",
    method: "post",
    data: data
  });
}

export function upload_coach_from_excel(data) {
  return request({
    url: "/maintain/upload_coach_from_excel",
    method: "post",
    data: data
  });
}

export function upload_player_coach_map_from_excel(data) {
  return request({
    url: "/maintain/upload_player_coach_map_from_excel",
    method: "post",
    data: data
  });
}
export function upload_transport_from_excel(data) {
  return request({
    url: "/maintain/upload_transport_from_excel",
    method: "post",
    data: data
  });
}
export function upload_injury_record_from_excel(data) {
  return request({
    url: "/maintain/upload_injury_record_from_excel",
    method: "post",
    data: data
  });
}
export function upload_Match_from_excel(data) {
  return request({
    url: "/maintain/upload_Match_from_excel",
    method: "post",
    data: data
  });
}

export function fileDownload_transmission(data) {
  return request({
    url: "/person/transport/fileDownload/" + data,
    method: "post",
    responseType: "blob"
  });
}

export function fileDownload_match(data) {
  return request({
    url: "/match/fileDownload/" + data,
    method: "post",
    responseType: "blob"
  });
}

//各级各类体校填报
export function insert_update(data) {
  return request({
    url: "/data/total_f_sheet2/insert_update",
    method: "post",
    headers: { "Content-Type": "application/json; charset=UTF-8" },
    data: data
  });
}

//年度信息填报
export function train_update(data) {
  return request({
    url: "/data/train_data/insert_update",
    method: "post",
    headers: { "Content-Type": "application/json; charset=UTF-8" },
    data: data
  });
}
